import React from 'react';
import { MenuItem, FormControl, Button, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as ExpandMore } from 'assets/icons/arrow-down.svg';
import { ReactComponent as WebIcon } from 'mui/assets/icons/web.svg';

import { DS_palette as corePalette } from 'mui/base/theme/DS_Tokens/core';
import { DS_spacing as coreSpacing } from 'mui/base/theme/DS_Tokens/core';
import Link from '../Link';
import getLocaleData from './utils/getLocaleData';

import { StyledWrapperLocaleSelector, StyledSelect, StyledSvgWorldIcon } from './DS_LocaleSwitcherStyles';

function DS_LocaleSwitcher() {
  const allLocaleData = getLocaleData();

  const newLocaleData = Object.entries(allLocaleData.rest).reduce((acc, [key, value]) => {
    if (key !== 'en-GB' && key !== 'de-CH' && key !== 'pl' && key !== 'de-AT') acc[key] = value;
    return acc;
  }, {});

  const [locale, setLocale] = React.useState(allLocaleData.default.name);
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const handleChange = e => {
    setLocale(e.target.value);
  };

  return (
    <StyledWrapperLocaleSelector>
      <StyledSvgWorldIcon component={WebIcon} inheritViewBox={true} />
      <FormControl>
        <StyledSelect
          variant="standard"
          data-test="select-locale"
          value={locale}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'country select' }}
          IconComponent={ExpandMore}
          MenuProps={{
            anchorOrigin: {
              vertical: 'center',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            PaperProps: {
              className: 'select-locale',
            },
            sx: {
              zIndex: 2000,
              '& .select-locale .MuiButtonBase-root': {
                color: `${corePalette.black[900]}`,
              },
              '& .select-locale .MuiMenuItem-root': {
                minHeight: `${coreSpacing.rem.xl}`,
                padding: 0,
              },
              '& .select-locale .MuiMenuItem-root:hover': {
                backgroundColor: `${corePalette.grey[100]}`,
              },

              '& .select-locale.MuiPaper-root': {
                borderRadius: `${coreSpacing.rem.xxs}`,
                marginTop: `${coreSpacing.rem.xxs}`,
              },
              '& .select-locale .Mui-selected > span': {
                margin: '0 auto',
              },
              '& .select-locale .Mui-selected': {
                backgroundColor: `${corePalette.grey[100]} !important`,
              },
            },
          }}
        >
          <MenuItem value={locale}>
            {' '}
            <Typography
              variant={isDesktop ? 'DS_labelSmallBold' : 'DS_copyMediumBold'}
              component="span"
              aria-label={locale}
            >
              {locale}
            </Typography>
          </MenuItem>
          {Object.values(newLocaleData).map(item => (
            <MenuItem key={item.name} value={item.name}>
              <Button component={Link} url={item.url} rel={null} target={null}>
                <Typography variant={isDesktop ? 'DS_labelSmallBold' : 'DS_copyMediumBold'} component="span">
                  {item.name}
                </Typography>
              </Button>
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </StyledWrapperLocaleSelector>
  );
}

export default DS_LocaleSwitcher;
